export const navigationRoutes = {
  NEWS_FEED: 'newsfeed',
  EXPLORE: 'explore',
  DIRECTORY: 'directory',
  CALENDAR: 'calendar'
}
